import { mapGetters } from "vuex";
import _ from "lodash";
import { canAccessState } from "../../../grouppermissions/utils";

export default {
    methods: {
        filter_section(section) {
            const vm = this;
            var section_children = [];

            if (section && section.children) {
                _.forEach(section.children, function (child) {
                    if (child) {
                        if (child.to && child.to.name) {
                            var name = child.to.name;

                            var hasPermissions = canAccessState(
                                vm._group_permissions,
                                name
                            );

                            if (hasPermissions) {
                                section_children.push(child);
                            }
                        }
                        if ("children" in child) {
                            // has children so filter the 'children'
                            var new_section = vm.filter_section(child);
                            if (new_section) {
                                section_children.push(new_section);
                            }
                        }
                    }
                });

                if (section_children.length > 0) {
                    var newSection = _.cloneDeep(section);

                    newSection.children = section_children; // Use the filtered list

                    return newSection;
                }
            }
            return null; // no section
        },
    },
    computed: {
        ...mapGetters({ _group_permissions: "AuthModule/permissions" }),
        filtered_items() {
            var vm = this;

            if (!vm._group_permissions) {
                return this.items;
            } else {
                var result = [];
                _.forEach(this.items, function (section) {
                    var newSection = vm.filter_section(section);
                    if (newSection) {
                        result.push(newSection);
                    }
                });

                return result;
            }
        },
    },
};
